import React from "react";
import { Col, Row } from 'tea-component';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import Abnormal from '@/pages/intelligence/components/Abnormal';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import BlockbusterGamesCard from '@/pages/intelligence/components/CardComponents/BlockbusterGamesCard';

export default function CardModule(props) {
  const { title, gameData, date, tips, isLoading, handleTitleClick } = props;
  return (
    <CardSlot
        className="dbi-insights-page-card"
        iconList={[]}
        title={
          <div className="insights-gamehead">
            <div className="insights-gamehead-title">
              {title}
              <TipContext
                className="insights-gamehead-tip"
                tipText={tips}
              />
            </div>
            <div className="insights-gamehead-text">{date}</div>
          </div>
        }
      >
        <Abnormal
          isLoading={isLoading}
          isNoData={!isLoading && !gameData?.length}
          component={
            <Row>
              {gameData?.map((item: any, index: any) => {
                return (
                  <Col
                    span={
                      gameData.length == 1
                        ? 12
                        : 24 / gameData.length
                    }
                    key={index}
                  >
                    <BlockbusterGamesCard
                      data={item}
                      onClick={handleTitleClick}
                    />
                  </Col>
                );
              })}
            </Row>
          }
        />
      </CardSlot>
  )
}